<template>
  <div class="common-page-main main-page">
    <div class="field-box scroll-cotar">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Transport Roller Classification Management</span>
        </div>
        <div class="rfp">
          <el-button size="small" icon="plus" type="primary" @click="showAddPop()">add</el-button>
          <el-button size="small" type="primary" v-if="$route.query.code != null" @click="goBack()">back</el-button>
        </div>
      </div>
      <div class="table-wrap">
        <el-table :data="table.data" v-loading="table.isLoading" element-loading-text="LOADING" style="width: 100%">
          <el-table-column prop="PsName" label="type"></el-table-column>
          <el-table-column label="Operate">
            <template scope="scope">
              <el-button size="small" v-on:click="showUpdatePop(scope.$index, scope.row)">edit</el-button>
              <el-button size="small" v-on:click="SkipNextGrade(scope.$index, scope.row)" v-if="scope.row.PsType < 3">next level</el-button>
              <el-button size="small" v-on:click="handleDel(scope.$index, scope.row)">delete</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <el-pagination v-on:current-change="handleTableCurrentChange" :current-page="table.currentPage" :page-size="table.pageSize" layout="total, prev, pager, next" :total="table.pageTotal">
        </el-pagination>
      </div>
    </div>
    <!-- 详情弹出层 -->
    <el-dialog title="product detail" :visible.sync="page.popShow" size="tine">
      <ProductTypeFormSSGT @addSuccess="handleAdd" @updateSuccess="handleUpdate" ref="popForm"></ProductTypeFormSSGT>
    </el-dialog>
  </div>
</template>

<script>
// import $ from 'jquery'
// import mixin from '@/components/common/mixin'
import tools from '@/components/common/tools'
import ProductTypeFormSSGT from '@/components/product/ProductTypeFormSSGT'

// 表格相关操作
let table = {
  methods: {
    getTableData: tools.commonTableDateFetch({
      url: '/Ajax/GetProselectSsgtListInAdmin',
      data() {
        var PsLastCode = this.$route.query.code
        return {
          PsLastCode: PsLastCode == null ? '0' : PsLastCode
        }
      },
      success(response) {
        let result = response.data
        this.table.data = result
      }
    }),
    refreshTableData() {
      this.getTableData(this.table.currentPage)
    }
  }
}

// 路径页面进入数据获取
let routeDataGet = {
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route': 'fetchData'
  },
  methods: {
    fetchData() {
      this.getTableData()
    }
  }
}

// 请求相关操作
let page = {
  methods: {
    // 删除操作
    delDataAjax(id) {
      tools.commonAjax.call(this, true, '/Ajax/DeleteProselectSsgtInAdmin', {
        PsCode: id
      }).then(() => {
        this.$message.success('delete success!')
        // 重新获取列表数据
        this.refreshTableData()
      })
    }
  }
}

export default {
  name: 'ProductTypeSSGT',
  mixins: [routeDataGet, table, page],
  components: {
    ProductTypeFormSSGT
  },
  created() {
    this.getTableData()
  },
  data() {
    return {
      table: {
        isLoading: false, // 是否正在加载
        ajaxData: {
          OrderName: ''
        }, // 额外请求参数
        data: [], // 表格当前数据
        currentPage: 1, // 当前页码
        pageSize: 15, // 每页条数
        pageTotal: 0 // 总页数
      },
      page: {
        popShow: false
      }
    }
  },
  computed: {
  },
  methods: {
    // 页码点击事件
    handleTableCurrentChange(val) {
      this.getTableData(val)
    },
    // 显示add弹出层
    showAddPop() {
      var PsLastCode = this.$route.query.code
      this.page.popShow = true
      this.$nextTick(function() {
        this.$refs.popForm.resetValue()
        this.$refs.popForm.setValue({
          PsLastCode: PsLastCode == null ? '0' : PsLastCode
        })
      })
    },
    // 显示修改弹出层
    showUpdatePop(idx, item) {
      this.page.popShow = true
      this.$nextTick(function() {
        this.$refs.popForm.setValue(item)
      })
    },
    // add操作
    handleAdd() {
      // 刷新表格数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 修改操作
    handleUpdate() {
      // 刷新表格数据
      this.refreshTableData()
      this.page.popShow = false
    },
    // 删除操作
    handleDel(idx, item) {
      this.$confirm('This will permanently delete the record', 'prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Canel',
        type: 'warning'
      }).then(() => {
        this.delDataAjax(item.PsCode)
      })
    },
    // 跳转下一级
    SkipNextGrade(idx, item) {
      // this.refreshTableData()
      this.$router.push(`ProductTypeSSGT?code=${item.PsCode}`)
    },
    goBack() {
      window.history.go(-1)
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>



// WEBPACK FOOTER //
// ProductTypeSSGT.vue?14f62f28